export const ALLOWED_ROLES = {
  OPS_OWNER: 'opsowner',
  OPS: 'ops',
  OPS_VIEWER: 'opsviewer',
  EXTERNAL: 'external'
}

// ----- ROLE → ALLOWED REFUND % -----
export const REFUND_ROLE_PERCENT = {
  [ALLOWED_ROLES.OPS_OWNER]: 100,
  [ALLOWED_ROLES.OPS]: 30,
  [ALLOWED_ROLES.OPS_VIEWER]: 0,
  [ALLOWED_ROLES.EXTERNAL]: 0
}
